import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import {
  NavController,
  LoadingController,
  ModalController,
  PopoverController,
  Platform,
  MenuController,
} from '@ionic/angular';
import { ActivatedRoute, Router, NavigationExtras } from '@angular/router';

import { Storage } from '@ionic/storage';

import { Barber } from '../../models/barber';
import { Constants } from '../../models/constants';
import { SelectedServiceTypeList } from '../../models/selected-service-type-list';
import { ServiceType } from '../../models/service-type';
import {
  PublicEventInfo,
  EventBarberAndTimeslots,
} from '../../models/public-event-info';
import {
  EventServiceOffering,
  PublicEventTimeslot,
} from '../../models/public-event-info';

import { CloudCode } from '../../services/cloudcode';
import { FavoriteBarberService } from '../../services/favorite-barber-service';
import { ApptCreator } from '../../services/appt-creation-service';
import { Timezones } from '../../services/timezones';
import { UserService } from '../../services/user-service';
import { Util } from '../../services/util';
import { Alert } from '../../services/alert';
import {
  BarberAvailService,
  AvailData,
  BarberTimeslot,
} from '../../services/barber-avail-service';
import { PromoService } from '../../services/promo-service';
import { BarberService } from '../../services/barber-service';
import { HomeService } from '../../services/home-service';
import { RoomTasks } from '../../services/room-tasks';
import { BusinessTasks } from '../../services/business-tasks';
import { NavParamsHistoryStore } from '../../services/nav-params-history-store';
import { AnalyticsService } from '../../services/analytics-service';
import { DeviceService } from '../../services/device-service';
import { EventService } from '../../services/event-service';
import { DeeplinkRoutingService } from '../../services/deeplink-routing-service';

import { ServicesListPage } from '../services-list/services-list.page';
import { EnterAddressPage } from '../enter-address/enter-address.page';
import { MoreReviewsPage } from '../more-reviews/more-reviews.page';
import { MetaTagService } from 'src/app/services/meta-tag-service';
import { ObservableService } from 'src/app/services/observable-service';

declare var PhotoSwipe: any;
declare var PhotoSwipeUI_Default: any;

interface BarberPhoto {
  url: string;
  id: string;
  width?: number;
  height?: number;
}

@Component({
  selector: 'app-barber-profile',
  templateUrl: './barber-profile.page.html',
  styleUrls: ['./barber-profile.page.scss'],
})
export class BarberProfilePage implements OnInit {
  barberProfileNavHistory?: string;

  placeholderImg = 'assets/img/profile-placeholder.png';
  barber?: Barber;
  photos?: BarberPhoto[];
  barberLink: string;
  isFavorited: boolean;
  availData?: AvailData;
  canBook?: boolean;

  showOval: boolean = true;

  // Params for UI
  bookButtonTitle = '';
  selectedTimeslotDate?: Date;
  displayTimeslots: BarberTimeslot[];
  selectedAvailIndex = 0;
  showCustomAddress: boolean = false;

  eventID?: string;
  eventInfo?: PublicEventInfo;
  eventSelectedService?: EventServiceOffering;
  eventSelectedTimeslot?: PublicEventTimeslot;
  eventTimeslots?: PublicEventTimeslot[];

  titleOpacity = 0;
  titleOpaquenessStartPx = 96;
  titleOpaquenessEndPx = 140;

  datePickerOpen = false;

  page = 'BarberProfilePage';

  // Subscriptions
  private verifyPhoneSubscription?: any;

  constructor(
    private observables: ObservableService,
    private navCtrl: NavController,
    private navParamsHistoryStore: NavParamsHistoryStore,
    private popoverCtrl: PopoverController,
    private modalCtrl: ModalController,
    private loadingCtrl: LoadingController,
    private alert: Alert,
    public userService: UserService,
    private favoriteBarberService: FavoriteBarberService,
    private promoService: PromoService,
    private homeService: HomeService,
    private analytics: AnalyticsService,
    private storage: Storage,
    private router: Router,
    private route: ActivatedRoute,
    private changeRef: ChangeDetectorRef,
    public apptCreator: ApptCreator,
    private menuCtrl: MenuController,
    public deviceService: DeviceService,
    private eventService: EventService,
    private metaTagService: MetaTagService,
    private deeplinkRoutingService: DeeplinkRoutingService,
  ) {}

  ngOnInit() {
    this.userService.ensureAccountExists(
      () => {
        if (
          this.router.getCurrentNavigation() &&
          this.router.getCurrentNavigation().extras.state
        ) {
          // We came from nav push. Load in initial props.
          const { state: navState } = this.router.getCurrentNavigation().extras;
          if (navState) {
            if (navState.eventID) {
              this.eventID = navState.eventID;
              this.eventSelectedService = navState.selectedService;
              this.eventTimeslots = navState.timeslots;
              this.eventInfo = navState.eventInfo;
              this.eventSelectedTimeslot = this.eventTimeslots[0];
            } else {
              this.apptCreator.barberProfileNavHistory =
                navState.barberProfileNavHistory;
              this.barberProfileNavHistory = navState.barberProfileNavHistory;

              if (navState.apptDate) {
                this.apptCreator.apptTime.date = navState.apptDate;
              }

              this.canBook = navState.canBook;
            }
          }
        } else {
          // Blank settings if they refreshed this page, or just landed on it.
          this.eventID = this.route.snapshot.queryParamMap.get('event');
          this.route.queryParamMap.subscribe((queryParams) => {
            this.eventID = queryParams.get('event');
            if (this.eventID) {
              this.loadEventInfo();
            }
          });
        }

        this.barberLink = this.route.snapshot.paramMap.get('barberLink');

        if (
          this.apptCreator.address &&
          !this.apptCreator.address.street.length
        ) {
          if (this.userService.user && this.userService.user.address) {
            this.apptCreator.address = this.userService.user.address;
          }
        }

        this.getBarber();
      },
      (errMsg: string) => {
        this.error('Could not load page. Please refresh.');
      },
    );

    const isEvent = Util.isDefined(this.eventID);
    if (isEvent) {
      this.verifyPhoneSubscription =
        this.observables.verifyPhoneComplete.subscribe(() => {
          if (this.eventSelectedService && this.eventSelectedTimeslot) {
            this.bookEventPressed();
          }
        });
    }

    for (const serviceType of this.apptCreator.selectedServiceTypeList.items) {
      if (serviceType.isChatOnlyService) {
        this.apptCreator.selectedServiceTypeList =
          new SelectedServiceTypeList();
        break;
      }
    }
  }

  ngAfterViewInit() {
    this.analytics.track(AnalyticsService.ViewedProProfile);
  }

  ionViewWillEnter() {
    this.menuCtrl.enable(true);
  }

  ionViewDidEnter() {
    if (this.eventID) {
      this.observables.publishSetCurrentMenuRoot('/events');
    } else {
      this.observables.publishSetCurrentMenuRoot('/explore');
      this.storage.get(Constants.ADDRESS_IS_FROM_GPS).then((val) => {
        if (val == true) {
          this.alert.show(
            'Please confirm your address - is this correct?',
            Util.formatAddress(this.apptCreator.address),
            'Yes',
            () => {
              this.storage.set(Constants.ADDRESS_IS_FROM_GPS, false);
            },
            'No',
            () => {
              this.openAddress();
            },
          );
          return;
        }
      });
    }
  }

  ngOnDestroy() {
    if (this.verifyPhoneSubscription) {
      this.verifyPhoneSubscription.unsubscribe();
    }
  }

  // Loading functions

  private updatePageTitle() {
    if (this.eventID) {
      if (!this.eventInfo || !this.barber) {
        return;
      }

      this.metaTagService.updateTitle(
        `${this.barber.fullName} for ${this.eventInfo.name}`,
      );
    } else {
      this.metaTagService.updateTitle(`${this.barber.fullName}`);
    }

    this.metaTagService.updateTags({
      facebookURL: `https://app.getshortcut.co/pro/${this.barberLink}`,
      keywords: 'local barber, local stylist, barber profile, view services',
      facebookTitle: `${this.barber.fullName} | Shortcut`,
      twitterTitle: `${this.barber.fullName} | Shortcut`,
      description: `View ${this.barber.firstName}'s services and book a Shortcut appointment.`,
      facebookDescription: `View ${this.barber.firstName}'s services and book a Shortcut appointment.`,
      twitterDescription: `View ${this.barber.firstName}'s services and book a Shortcut appointment.`,
    });
  }

  private getBarber() {
    if (!this.barber) {
      var isEvent = Util.isDefined(this.eventID);

      BarberService.pullBarberInfo(
        this.barberLink,
        isEvent,
        (barber: Barber) => {
          if (isEvent) {
            this.loadedBarber_Event(barber);
          } else {
            this.loadedBarber(barber);
          }
        },
        (msg: string) => {
          if (!Util.isNavigationError(msg)) {
            this.error(msg);
          }
        },
      );
    } else {
      this.apptCreator.barber = this.barber;
      this.validateSelectedServiceTypes();
      this.fetchTimezoneInfo();
    }
  }

  private loadedBarber(barber: Barber) {
    this.barber = barber;
    this.updatePageTitle();

    this.isFavorited = this.favoriteBarberService.isFavorited(this.barber.id);
    this.getPhotos();

    this.apptCreator.barber = this.barber;
    this.validateSelectedServiceTypes();
    this.fetchTimezoneInfo();
  }

  private loadedBarber_Event(barber: Barber) {
    this.barber = barber;
    this.updatePageTitle();

    this.isFavorited = this.favoriteBarberService.isFavorited(this.barber.id);
    this.getPhotos();
    this.changeRef.detectChanges();
  }

  private loadEventInfo() {
    this.eventService.pullPublicEventInfo(
      this.eventID,
      (eventInfo: PublicEventInfo) => {
        this.eventInfo = eventInfo;
        this.updatePageTitle();
        this.changeRef.detectChanges();
      },
      (errorMsg: string) => {
        if (!Util.isNavigationError(errorMsg)) {
          this.error(
            'Event not found. Please select "Join an event" and enter your event code to view upcoming dates.',
          );
        }
      },
    );
  }

  private error(msg: string) {
    this.alert.show('Error', msg);
  }

  private getPhotos() {
    if (!this.barber) {
      console.error('no Pro loaded - cannot pull photos');
      return;
    }

    CloudCode.run(
      'pullBarberPhotos',
      { barberID: this.barber.id },
      (photos: BarberPhoto[]) => {
        this.photos = photos;
        this.changeRef.detectChanges();
      },
      (msg: string) => {
        if (!Util.isNavigationError(msg)) {
          this.error(msg);
        }
      },
    );
  }

  private replaceServicesWithBarbersFirstService() {
    this.homeService.pullActiveHomeServices_Categories(
      this.barber.proType,
      (serviceTypes: ServiceType[], categories: string[]) => {
        let firstBarberServiceTypeID = this.barber.serviceIDs[0];
        let serviceTypeList = new SelectedServiceTypeList();

        let title = 'Service';
        let isChatOnlyService = false;
        for (let serviceType of serviceTypes) {
          if (serviceType.id == firstBarberServiceTypeID) {
            title = serviceType.title;
            isChatOnlyService = serviceType.isChatOnlyService;
          }
        }

        serviceTypeList.addNewItem(
          firstBarberServiceTypeID,
          title,
          1,
          isChatOnlyService,
        );
        this.apptCreator.selectedServiceTypeList = serviceTypeList;
        this.changeRef.detectChanges();
      },
      (errorMsg: string) => {
        console.log(errorMsg);
      },
    );
  }

  private validateSelectedServiceTypes() {
    for (let serviceType of this.apptCreator.selectedServiceTypeList.items) {
      if (!Util.contains(this.barber.serviceIDs, serviceType.id)) {
        this.replaceServicesWithBarbersFirstService();
        return;
      }
    }
  }

  private fetchTimezoneInfo(force: boolean = false) {
    if (this.apptCreator.apptTime.timezone && !force) {
      this.fetchBarberAvails();
    } else {
      Timezones.timezoneInfoForAddress(
        this.apptCreator.address,
        this.apptCreator.apptTime.date,
        (timezone) => {
          this.apptCreator.apptTime.timezone = timezone;
          this.fetchBarberAvails();
        },
        (errorMsg) => {
          console.log(`Timezone info for address failed: ${errorMsg}`);
          // Set address zip to nothign to force some UI that instructs user to choose a new address.
          this.apptCreator.address.zip = '';
          this.fetchBarberAvails();
        },
      );
    }
  }

  fetchBarberAvails(refresher?: any) {
    if (this.userService.isBusiness) {
      if (refresher) {
        refresher.target.complete();
      }
      return;
    }

    BarberAvailService.fetch(
      this.barber.id,
      this.apptCreator.selectedServiceTypeList.items,
      this.apptCreator.address,
      this.barberProfileNavHistory,
      this.canBook,
      (availData) => {
        console.log(availData);

        this.availData = availData;
        this.updateSelectedDate(true);
        if (refresher) {
          refresher.target.complete();
        }
        this.changeRef.detectChanges();
      },
      (errorMsg) => {
        console.error(errorMsg);
        if (refresher) {
          refresher.target.complete();
        }
      },
    );
  }

  private updateSelectedDate(
    selectByClosestDate: boolean,
    selectIndex: number = 0,
  ) {
    let selectedTimeslot: BarberTimeslot;
    let displayTimeslots: BarberTimeslot[] = [];
    var selectedIndex = 0;

    if (this.apptCreator.apptTime.date) {
      let apptDate = this.apptCreator.apptTime.date;
      for (let i = 0; i < this.availData.dates.length; i++) {
        let date = this.availData.dates[i];
        if (Util.isSameDay(date, apptDate)) {
          displayTimeslots = this.availData.sortedTimeslots[i];
          if (selectByClosestDate) {
            let timeslotDates: Date[] = [];
            for (let timeslot of displayTimeslots) {
              timeslotDates.push(timeslot.date);
            }
            selectedIndex = Util.findClosestDate(apptDate, timeslotDates)[1];
            selectedTimeslot = displayTimeslots[selectedIndex];
          } else {
            selectedIndex = selectIndex;
            selectedTimeslot = displayTimeslots[selectIndex];
          }
        }
      }
    }

    if (!selectedTimeslot) {
      displayTimeslots = this.availData.sortedTimeslots[0];
      selectedTimeslot = displayTimeslots[0];
    }

    this.apptCreator.apptTime.date = selectedTimeslot.date;
    this.apptCreator.availID = selectedTimeslot.id;

    this.selectedAvailIndex = selectedIndex;
    this.selectedTimeslotDate = selectedTimeslot.date;
    this.displayTimeslots = displayTimeslots;
    let data = {};
    if (this.router.getCurrentNavigation()) {
      data = this.router.getCurrentNavigation().extras.state;
    }
    this.navParamsHistoryStore.save(this.page, data, this.apptCreator);
    this.bookButtonTitle =
      'Book at ' +
      Util.prettyTimeAdjusted(
        selectedTimeslot.date,
        this.apptCreator.apptTime.timezone,
      );

    this.showCustomAddress = false;
    for (let timeslot of displayTimeslots) {
      if (timeslot.address) {
        this.showCustomAddress = true;
        break;
      }
    }

    this.changeRef.detectChanges();
  }

  roundedRating() {
    return Math.round(this.barber.averageRating);
  }

  displayDate(date: Date) {
    return Util.dayMonthDate(date, undefined);
  }

  datesEqual(date1: Date, date2: Date) {
    return date1.getTime() == date2.getTime();
  }

  // Actions

  async goToChat() {
    if (this.userService.user.isGuest) {
      const preventMainRefresh = true;
      const isEvent = Util.isDefined(this.eventID);
      const source = isEvent ? 'event' : '';
      this.observables.publishGoToSignUp(preventMainRefresh, source);
      return;
    }

    let func = RoomTasks.createClientBarberRoom;

    if (this.userService.isBusinessAccount()) {
      func = RoomTasks.createBusinessBarberRoom;
    }

    const loading = await this.loadingCtrl.create();
    loading.present();

    func(
      this.barber.id,
      (roomID: string) => {
        loading.dismiss();
        this.observables.publishOpenNewChat(roomID);
      },
      (errorMsg: string) => {
        loading.dismiss();
        this.alert.show('Oops!', errorMsg);
      },
    );
  }

  toggleFavoriteBarber() {
    if (this.isFavorited) {
      this.unFavoriteBarber();
    } else {
      this.favoriteBarber();
    }
  }

  async bookEventPressed() {
    if (this.userService.user.isGuest) {
      const preventMainRefresh = true;
      const isEvent = Util.isDefined(this.eventID);
      const source = isEvent ? 'event' : '';
      this.observables.publishGoToSignUp(preventMainRefresh, source);
      return;
    }

    let loading = await this.loadingCtrl.create();
    loading.present();

    this.eventService.lockEventTimeslot(
      this.eventSelectedTimeslot.id,
      () => {
        loading.dismiss();

        let inFiveMinutes = Util.addMinutes(new Date(), 5);

        let navigationExtras: NavigationExtras = {
          state: {
            previousController: `/pro/${this.barberLink}?event=${this.eventID}`,
            barber: this.barber,
            expiryDate: inFiveMinutes,
            eventInfo: this.eventInfo,
            eventSelectedService: this.eventSelectedService,
            eventSelectedTimeslot: this.eventSelectedTimeslot,
          },
        };
        this.navCtrl.navigateForward(
          `/confirm-event/${this.eventInfo.mobileEventCode}`,
          navigationExtras,
        );
      },
      (errorMsg) => {
        loading.dismiss();
        this.alert.show('Timeslot unavailable', errorMsg);
        this.loadEventInfo();
      },
    );
  }

  bookPressed() {
    if (this.userService.user.isGuest) {
      const preventMainRefresh = true;
      const isEvent = Util.isDefined(this.eventID);
      const source = isEvent ? 'event' : '';
      this.observables.publishGoToSignUp(preventMainRefresh, source);
      return;
    }

    this.executeBookPressed();
  }

  async executeBookPressed() {
    this.analytics.track(AnalyticsService.RequestAppt);

    let date = this.apptCreator.apptTime.date;
    if (date) {
      let loading = await this.loadingCtrl.create();
      loading.present();
      this.apptCreator.requestApptTime(
        () => {
          loading.dismiss();

          this.apptCreator.apptRequestID = undefined;
          this.apptCreator.type = 'v3 book';

          let navigationExtras: NavigationExtras = {
            state: {
              previousController: `/pro/${this.barberLink}`,
            },
          };
          this.navCtrl.navigateForward('/confirm-booking', navigationExtras);
        },
        (errorMsg) => {
          loading.dismiss();
          if (this.apptCreator.coupon) {
            // User added a coupon. Present alert giving user the option to remove their coupon.
            this.alert.show(
              'Error',
              errorMsg,
              'Ok',
              () => {},
              'Remove Promo',
              () => {
                this.apptCreator.coupon = null;
                this.promoService.clearCoupon();
              },
            );
          } else {
            this.alert.show('Timeslot unavailable', `${errorMsg}`);
          }
          this.fetchBarberAvails();
        },
      );
    } else {
      this.alert.show('Error', 'Please select an appointment time.');
    }
  }

  photoLoaded(event: any, photo: BarberPhoto) {
    if (event && event.target) {
      const width = event.target.naturalWidth;
      const height = event.target.naturalHeight;
      photo.width = width;
      photo.height = height;
    }
  }

  photoTapped(photo: BarberPhoto, selectedIndex: number) {
    this.analytics.track(AnalyticsService.ViewProProfilePhotos);
    let pswpElement = document.querySelectorAll('.pswp')[0];

    let items = this.photos.map((photo) => {
      return {
        src: photo.url,
        w: photo.width || 500,
        h: photo.height || 500,
      };
    });

    let options = {
      index: selectedIndex,
      bgOpacity: 0.7,
      shareEl: false,
      fullscreenEl: false,
    };

    // Initializes and opens PhotoSwipe
    let gallery = new PhotoSwipe(
      pswpElement,
      PhotoSwipeUI_Default,
      items,
      options,
    );
    gallery.init();
  }

  async showMoreReviews() {
    this.analytics.track(AnalyticsService.ViewMoreReviews);

    let moreReviewsModal = await this.modalCtrl.create({
      component: MoreReviewsPage,
      componentProps: {
        barber: this.barber,
      },
    });

    moreReviewsModal.present();
  }

  async openServices() {
    if (this.eventID) {
      this.openServices_Event();
      return;
    }

    let servicesModal = await this.modalCtrl.create({
      component: ServicesListPage,
      componentProps: {
        loadFromPage: true,
        proType: this.barber.proType,
        selectedServiceTypeList: this.apptCreator.selectedServiceTypeList,
        barberServiceIDs: this.barber.serviceIDs,
        barberPrices: this.barber.servicePricing,
        barberCurrency: this.barber.currency,
      },
      cssClass: 'SCWEB-services-modal',
    });

    servicesModal.onDidDismiss().then((val: any) => {
      if (!val || !val.data) {
        return;
      }

      if (val.data.goToChat) {
        setTimeout(() => {
          this.goToChat();
        }, 50);
        return;
      }

      if (val.data.newSelectedServiceList) {
        this.apptCreator.selectedServiceTypeList =
          val.data.newSelectedServiceList;
        let data = {};
        if (this.router.getCurrentNavigation()) {
          data = this.router.getCurrentNavigation().extras.state;
        }
        this.navParamsHistoryStore.save(this.page, data, this.apptCreator);
        this.fetchBarberAvails();
      }
    });

    servicesModal.present();
  }

  async openServices_Event() {
    if (!this.eventInfo) {
      this.error('Loading, please wait and try again.');
      return;
    }

    let servicesModal = await this.modalCtrl.create({
      component: ServicesListPage,
      componentProps: {
        eventTabTitle: this.eventInfo.name,
        eventID: this.eventID,
        eventServiceOfferings: this.eventInfo.serviceOfferings,
        eventCurrency: this.eventInfo.currency,
      },
      cssClass: 'SCWEB-services-modal',
    });

    servicesModal.onDidDismiss().then((val: any) => {
      if (!val || !val.data) {
        return;
      }

      if (val.data.selectedService) {
        this.eventSelectedService = val.data.selectedService;
        this.getEventTimeslots();
      }
    });

    servicesModal.present();
  }

  async joinWaitlist() {
    if (this.userService.user.isGuest) {
      let preventMainRefresh = true;
      const isEvent = Util.isDefined(this.eventID);
      const source = isEvent ? 'event' : '';
      this.observables.publishGoToSignUp(preventMainRefresh, source);
      return;
    }

    let loading = await this.loadingCtrl.create();
    loading.present();

    this.eventService.joinWaitlist(
      this.eventID,
      () => {
        loading.dismiss();
        this.alert.show(
          'Success',
          "You've been added to the waitlist. You'll be notified with any updates to availability.",
          'Ok',
          () => {
            this.observables.publishJoinedWaitlist();
          },
        );
      },
      (errorMsg: string) => {
        loading.dismiss();
        this.alert.show('Error', errorMsg);
      },
    );
  }

  private getEventBarber() {
    if (!this.eventInfo) {
      this.error('Loading, please wait and try again.');
      return;
    }

    // TODO

    // let barbersAndTimeslots = this.eventInfo.barbersAndTimeslots;

    // for (var i = 0; i < barbersAndTimeslots.length; i++) {
    //   if (barbersAndTimeslots[i].barber.id == this.barber.id) {
    //     return barbersAndTimeslots[i].barber
    //   }
    // }
  }

  private async getEventTimeslots() {
    if (this.eventSelectedService && this.barber && this.eventInfo) {
      const loading = await this.loadingCtrl.create();
      loading.present();

      this.eventService.pullEventProsAndTimeslotsForService(
        this.eventID,
        this.eventSelectedService.id,
        (prosAndTimeslots: EventBarberAndTimeslots[]) => {
          loading.dismiss();

          for (var i = 0; i < prosAndTimeslots.length; i++) {
            if (prosAndTimeslots[i].pro.id == this.barber.id) {
              if (prosAndTimeslots[i].timeslots.length) {
                this.eventSelectedTimeslot = prosAndTimeslots[i].timeslots[0];
                this.eventTimeslots = prosAndTimeslots[i].timeslots;
                this.changeRef.detectChanges();
                return;
              }
            }
          }
          this.eventSelectedTimeslot = null;
          this.eventTimeslots = null;
          this.changeRef.detectChanges();
        },
        (errMsg: string) => {
          console.log(errMsg);
          this.alert.show(
            'Oops',
            'Something went wrong fetching the available timeslots. Please select your service again.',
          );
          loading.dismiss();
        },
      );
    }
  }

  async openAddress(event?: any) {
    const addressModal = await this.popoverCtrl.create({
      component: EnterAddressPage,
      componentProps: {},
      event: event,
      cssClass: ['SCWEB-popover', 'SCWEB-popover-address'],
    });

    addressModal.onDidDismiss().then((val: any) => {
      if (!val || !val.data) {
        return;
      }

      if (val.data.address) {
        this.analytics.track(AnalyticsService.EnteredAddress_BarberProfile);
        const fromGPS = val.data.isFromGPS;
        this.storage.set(Constants.ADDRESS_IS_FROM_GPS, fromGPS);
        this.apptCreator.address = val.data.address;
        this.userService.update(
          {
            address: val.data.address,
          },
          () => {
            this.userService.fetch(() => {
              this.changeRef.detectChanges();
            });
          },
          (errorMsg) => {},
        );
        this.fetchTimezoneInfo(true);
      }
    });

    addressModal.present();
  }

  openAppLink() {
    this.alert.show(
      'Download Shortcut',
      `Book ${this.barber.firstName} for an in-home service through the award-winning Shortcut app.`,
      `View ${this.barber.firstName} in Shortcut`,
      () => {
        window.open(`https://shortcut.app.link/${this.barberLink}`, '_blank');
      },
    );
  }

  goBack() {
    this.showOval = false;
    this.changeRef.detectChanges();

    if (this.userService.isBusiness) {
      this.navCtrl.navigateBack('/team');
      return;
    }

    if (this.eventID) {
      this.navCtrl.navigateBack(`/event-details/${this.eventID}`);
      return;
    }

    const queryParams = this.deeplinkRoutingService.storedBusinessID
      ? { b: this.deeplinkRoutingService.storedBusinessID }
      : undefined;
    this.navCtrl.navigateRoot('/explore', { queryParams });
  }

  // Business tasks

  async resetProPassword() {
    let loading = await this.loadingCtrl.create();
    loading.present();

    BusinessTasks.resetProPassword(
      this.barber.id,
      () => {
        loading.dismiss();
        this.alert.show(
          'Password Reset Successfully',
          `${this.barber.firstName} was sent an email to update the password.`,
        );
      },
      (errorMsg: string) => {
        loading.dismiss();
        this.alert.show('Oops!', errorMsg);
      },
    );
  }

  viewAsAdmin() {
    window.open(
      `${Constants.SCC_ADMIN_URL}/#/businessPro/${this.barber.id}`,
      '_blank',
    );
  }

  proLink() {
    return `${Constants.APP_LINK_URL}/${this.barber.link}`;
  }

  // async activatePro() {

  //   let loading = await this.loadingCtrl.create()
  //   loading.present()

  //   BusinessTasks.activatePro(this.barber.id, () => {
  //     loading.dismiss()
  //     this.barber.active = true
  //     this.alert.show('Pro Activated Successfully', '')
  //     this.changeRef.detectChanges()
  //   }, (errorMsg: string) => {
  //     loading.dismiss()
  //     this.alert.show('Oops!', errorMsg)
  //   })
  // }

  // async deactivatePro() {

  //   let loading = await this.loadingCtrl.create()
  //   loading.present()

  //   BusinessTasks.deactivatePro(this.barber.id, () => {
  //     loading.dismiss()
  //     this.barber.active = false
  //     this.alert.show('Pro Deactivated Successfully', '')
  //     this.changeRef.detectChanges()
  //   }, (errorMsg: string) => {
  //     loading.dismiss()
  //     this.alert.show('Oops!', errorMsg)
  //   })
  // }

  // Helpers

  roundToNearestHundredth(num: number) {
    return (Math.round(num * 100) / 100).toFixed(2);
  }

  yearsSince(year: number) {
    return new Date().getUTCFullYear() - year;
  }

  private favoriteBarber() {
    this.favoriteBarberService.favoriteBarber(
      this.barber.id,
      () => {
        this.isFavorited = true;
        this.changeRef.detectChanges();
      },
      (msg: string) => {
        this.error(msg);
      },
    );
  }

  private unFavoriteBarber() {
    this.favoriteBarberService.unfavoriteBarber(
      this.barber.id,
      () => {
        this.isFavorited = false;
        this.changeRef.detectChanges();
      },
      (msg: string) => {
        this.error(msg);
      },
    );
  }

  getDisplayStringForTimeslotDate(date: Date): string {
    if (this.eventID) {
      let timezone = {
        offset: this.eventInfo.timezoneOffset,
      };
      return Util.prettyTimeAdjusted(date, timezone);
    }

    if (!this.apptCreator.apptTime) return '';
    return Util.prettyTimeAdjusted(date, this.apptCreator.apptTime.timezone);
  }

  eventTimeslotPressed(timeslot: PublicEventTimeslot) {
    this.eventSelectedTimeslot = timeslot;
    this.changeRef.detectChanges();
  }

  availTimeslotPressed(timeslot: BarberTimeslot) {
    this.apptCreator.apptTime.date = timeslot.date;
    this.updateSelectedDate(true);
  }

  changeAvailDate() {
    this.datePickerOpen = true;
    this.changeRef.detectChanges();
  }

  selectAvailDate(date: Date) {
    this.closeDatePicker();
    this.apptCreator.apptTime.date = date;
    let selectByClosestDate = false;
    this.updateSelectedDate(selectByClosestDate, 0);
    this.changeRef.detectChanges();
  }

  closeDatePicker() {
    this.datePickerOpen = false;
    this.changeRef.detectChanges();
  }

  barberLastActiveDate() {
    if (!this.barber || !this.barber.dateLastActiveInMessages) {
      return 'today';
    }

    return Util.timestampDayLowercase(this.barber.dateLastActiveInMessages);
  }

  mmddyyDate(date: Date) {
    return Util.mmddyyDate(new Date(date));
  }

  toRange(n: number) {
    return Util.toRange(n);
  }
}
